/**
 * Sentry Error Tracking Configuration
 *
 * Tracks errors and performance in production.
 * Get your DSN from: https://sentry.io/settings/projects/
 */

import * as Sentry from "@sentry/react";

// Only initialize Sentry in production
if (import.meta.env.PROD) {
  Sentry.init({
    // Get this from Sentry dashboard: Settings → Projects → Client Keys (DSN)
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Environment (development, staging, production)
    environment: import.meta.env.MODE,

    // Integrations for enhanced tracking
    integrations: [
      // Trace user interactions and performance
      Sentry.browserTracingIntegration(),

      // Record user sessions when errors occur
      Sentry.replayIntegration({
        maskAllText: true, // Privacy: mask all text
        blockAllMedia: true, // Privacy: block images/videos
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions

    // Session Replay
    replaysSessionSampleRate: 0.1, // Capture 10% of all sessions
    replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors

    // Ignore specific errors
    ignoreErrors: [
      // Browser extensions
      'Non-Error promise rejection captured',
      'ResizeObserver loop limit exceeded',
      // Network errors
      'NetworkError',
      'Failed to fetch',
    ],

    // Before sending, scrub sensitive data
    beforeSend(event) {
      // Remove sensitive query params
      if (event.request?.url) {
        const url = new URL(event.request.url);
        ['token', 'key', 'password'].forEach(param => url.searchParams.delete(param));
        event.request.url = url.toString();
      }
      return event;
    },
  });
}

// Export for manual error tracking
export default Sentry;
